export enum CouponType {
  Percentage = 0,
  Fixed = 1,
  FreeDelivery = 2,
}

export interface CouponDto {
  id: number;
  code: string;
  name: string;
  description?: string;
  type: CouponType;
  typeText: string;
  discountValue: number;
  maxDiscountAmount?: number;
  minOrderAmount: number;
  maxUsageCount?: number;
  maxUsagePerUser?: number;
  usedCount: number;
  startDate: string;
  endDate: string;
  isActive: boolean;
  isFirstOrderOnly: boolean;
  storeId?: number;
  categoryId?: number;
  applicablePincodes?: string;
  createdAt: string;
}

export interface CouponCreateDto {
  code: string;
  name: string;
  description?: string;
  type: CouponType;
  discountValue: number;
  maxDiscountAmount?: number;
  minOrderAmount?: number;
  maxUsageCount?: number;
  maxUsagePerUser?: number;
  startDate: string;
  endDate: string;
  isActive?: boolean;
  isFirstOrderOnly?: boolean;
  storeId?: number;
  categoryId?: number;
  applicablePincodes?: string;
}

export type CouponUpdateDto = CouponCreateDto;

export interface CouponFilterParams {
  isActive?: boolean;
  storeId?: number;
  search?: string;
  page?: number;
  pageSize?: number;
}

export interface CouponValidateDto {
  code: string;
  orderAmount: number;
  storeId?: number;
}

export interface CouponValidateResponseDto {
  isValid: boolean;
  message?: string;
  discountAmount: number;
  coupon?: CouponDto;
}

